import React from 'react';
import ReactDOM from 'react-dom';

// The Search box.
export default class SearchBox extends React.Component {

	static defaultProps = {
		sendData: ''
	}

	constructor(props) {
		super(props);

		this.state = {
			locName : '',
			locLat : '',
			locLng : '',
		}

		this.onPlacesChanged = this.onPlacesChanged.bind(this);
	}

	onPlacesChanged() {

		const thePlace = this.searchBox.getPlaces();

		if ( thePlace && thePlace[0].formatted_address !== this.state.locName ) {

			const placeName = thePlace[0].formatted_address;
			const geoLat = thePlace[0].geometry.location.lat();
			const geoLng = thePlace[0].geometry.location.lng();

			// console.log(thePlace[0]);

			this.setState( { 
							locName: placeName,
							locLat: geoLat, 
							locLng: geoLng
						} );

			this.props.sendData( this.state );

		}
	}

	componentDidMount() {
		var input = ReactDOM.findDOMNode( this.refs.input );
		const google = window.google;

		this.searchBox = new google.maps.places.SearchBox( input );
		this.searchBox.addListener( 'places_changed', this.onPlacesChanged );
	}

	componentWillUnmount() {
		const google = window.google;

		// https://developers.google.com/maps/documentation/javascript/events#removing
		google.maps.event.clearInstanceListeners( this.searchBox );
	}

	render() {

		return <input ref="input" className={ this.props.className } placeholder={ this.props.placeholder } onChange={this.onPlacesChanged} type="text" / > ;
	}
}


// WEBPACK FOOTER //
// ./src/js/Searchbox.js